module.exports = __webpack_public_path__ + "img/product_7.b588903.webp";